import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as fontawesome from '@fortawesome/free-solid-svg-icons';
import { SportFilterService } from '../../../services/sport-filter.service';

@Component({
  selector: 'app-bottom-links',
  imports: [FontAwesomeModule, RouterModule],
  template: `
    <section class="bg-background py-10">
      <div
        class="container mx-auto flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4"
      >
        <div class="flex-1 space-y-4 p-4">
          <h3 class="text-lg font-bold uppercase">Sportilink</h3>
          <p class="text-sm">
            Explore a wide range of sports community groups, including Football,
            Tennis, Basketball, and many more. Whether you're a passionate
            athlete or just starting out, you'll find like-minded enthusiasts to
            share experiences, exchange tips, and discuss the latest trends in
            the world of sports. Join the conversation in our dedicated forums
            below and become part of a vibrant, growing community!
          </p>
        </div>
        <div class="flex-1 space-y-4 p-4">
          <h3 class="text-lg font-bold">Quick Links</h3>
          <div class="flex">
            <ul class="list-disc ml-4 space-y-4 text-sm flex-1">
              <li>
                <a
                  [routerLink]="['/clubs']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Clubs</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/coaches']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Coaches</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/sponsors']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Sponsors</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/match-sessions']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Sessions</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/tournaments']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Tournaments</a
                >
              </li>
            </ul>
            <ul class="list-disc ml-4 space-y-4 text-sm flex-1">
              <li>
                <a
                  [routerLink]="['/events']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Events</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/venues']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Venues</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/marketplace']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  >Marketplace</a
                >
              </li>
            </ul>
          </div>
          <hr />
          <div class="flex">
            <ul class="list-disc ml-4 space-y-4 text-sm flex-1">
              <li>
                <a [routerLink]="['/privacy-policy']">Privacy Policy</a>
              </li>
            </ul>
            <ul class="list-disc ml-4 space-y-4 text-sm flex-1">
              <li>
                <a [routerLink]="['/terms-of-use']">Terms of Use</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="flex-1 space-y-4 p-4">
          <h3 class="text-lg font-bold">Contact Us</h3>
          <div class="flex space-x-4 text-sm">
            <fa-icon class="flex-shrink-0" [icon]="fa.faPhone"></fa-icon>
            <a class="flex-1" href="tel:+6289501410294">+62-895-0141-0294</a>
          </div>
          <div class="flex space-x-4 text-sm">
            <fa-icon class="flex-shrink-0" [icon]="fa.faEnvelope"></fa-icon>
            <a class="flex-1" href="mailto:support@sportilink.com"
              >support&#64;sportilink.com</a
            >
          </div>
          <div class="flex space-x-4 text-sm">
            <fa-icon
              class="flex-shrink-0"
              [icon]="fa.faMapLocationDot"
            ></fa-icon>
            <address class="flex-1 not-italic">
              <a
                href="https://www.google.com/maps?q=-6.920585,107.602742"
                target="_blank"
              >
                Jl. Jendral Sudirman No.41A, Bandung, Jawa Barat, Indonesia,
                40241
              </a>
            </address>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: ``,
})
export class BottomLinksComponent {
  fa = fontawesome;

  constructor(public sportFilterService: SportFilterService) {}
}
